import { useScreenMessage } from '@gogame/screens';

import { discardMarketingPlan } from 'scenes/MarketingPlanning/MarketingPlanningWizard/sources/plan';

export const useDiscardMarketingPlan = process => {
  const { showSuccessMessage, showErrorMessage } = useScreenMessage();
  return data => {
    return process(discardMarketingPlan(data))
      .then(response => {
        showSuccessMessage(`Marketing Plan discarded`);
        return response;
      })
      .catch(e => {
        showErrorMessage(e.message);
        return Promise.reject(e);
      });
  };
};
